import {
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut
} from "firebase/auth";

import {auth, googleProvider} from "./firebase";

//Google sign in function
export const googleSignIn = async () => {
  try {
    await signInWithPopup(auth, googleProvider);
  } catch (error) {
    console.log(error);
  }
};


//Sign in using email & password function
export const signIn = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth,email,password);
    return true;
  } catch (error) {
    console.log(error.message);
    return false;
  }
};

//Creating user with email & password function
export const signUp = async (email, password) => {
    try{
      await createUserWithEmailAndPassword(auth, email, password);
    }
    catch(error){
      console.log(error);
    }
  }

//Log out user function
export const logOut = async() => {
    try {
      await signOut(auth);
    } catch (error) {
      console.log(error);
    }
}
